export default {
  header: {
    dark: "Dunkles Design",
    light: "Helles Design",
    system: "Browser-Design",
    environment: "Sie arbeiten in der Testumgebung",
    notification: {
      label: "Vorgangsbenachrichtigungen",
      status_processing: "Vorgang läuft",
      status_success: "Vorgang abgeschlossen, Ihre Datei ist bereit",
      status_error: "Der Vorgang ist fehlgeschlagen",
      status_unknown:
        "Verfolgung unterbrochen: Der Vorgang läuft möglicherweise noch auf dem Server, Ihr Browser kann dies jedoch nicht mehr bestätigen.",
      status_announcement: "{label}: {status}",
      empty: "Kein laufender Vorgang...",
      waiting: "Warte auf Informationen zum Vorgang",
      list: "Gesamten Verlauf anzeigen",
      load_more: "Mehr anzeigen",
      historic: "Vorgangsverlauf",
      download: "Herunterladen",
      file: "Ihre Datei",
    },
  },
  menu: "Menü",
  dashboard: {
    presentation: "Präsentation",
    contact: "Kontakt",
    partner: "Partner",
    communication: "Kommunikation",
    timeline: "Timeline",
    timeline_actions: {
      delete: {
        confirmation: "Möchten Sie diese Zeile wirklich löschen?",
        success: "Zeile erfolgreich gelöscht!",
      },
    },
    indicator: "Indikatoren",
    indicators: {
      see_details: "Details der Füllraten anzeigen",
      see_details_complete_triad: "Rate der vollständigen Trinômes",
      fill_rate: "Füllrate",
    },
    shared_docs: "Geteilte Dokumente",
    registration: "Anmeldungen",
    registration_apprentice: "Anmeldebereich (Auszubildende(r))",
    welcome_to_studea: "Willkommen auf Ihrem Studea-Portal!",
    welcome_to_dashboard: "Willkommen auf Ihrem Dashboard",
    your_actually_are: "Sie sind derzeit",
    // ST143-TI-17771 (b2): plain placeholder, no embedded HTML — the <strong> wrapping is done by <i18n-t>'s
    // "name" slot in HeaderComponent.vue, as real DOM markup, not by string concatenation.
    welcome_message: "Willkommen {name} auf Ihrem Studea-Portal!",
    no_training_course_archived: "Keine archivierte Gruppe",
    no_training_course_actived: "Keine aktive Gruppe",
    no_triad: "Kein Trinôme",
    triad_search_placeholder: "Benutzer suchen",
    triad_members: "Mitglieder des Trinômes",
    questionnaires_empty: "Kein Fragebogen auszufüllen",
    contract: {
      company_sheet: "Unternehmensblatt",
      type: "Vertragsart:",
      company: "Arbeitgeber:",
      dates: "Vertragsdaten:",
      rupture_date: "Auflösungsdatum",
      rupture_cause: "Auflösungsgrund",
      siret: "Siret:",
      address: "Adresse:",
      from: "Von",
      to: "bis",
      by: "von",
      secondary: "sekundär",
      reference_contract: "Referenzvertrag",
      vised_cerfa: "Geprüfter CERFA",
      mission_file: "Aufgabenblatt",
      rupture_justificative: "Begründungsdatei",
      rupture_invalidtion_confirmation: "Möchten Sie die Validierung dieser Vertragsauflösung wirklich annullieren?",
      rupture_declared: "Auflösung gemeldet am",
      rupture_validated: "Auflösung validieren",
      rupture_invalidate: "Auflösung ungültig machen",
      invalidate: "Ungültig machen",
      date_overlaps:
        "Einige Vertragsdaten überschneiden sich. Bitte speichern Sie die Auflösung des vorherigen Vertrags oder überprüfen Sie die in den Verträgen eingegebenen Daten",
      no_active_contract_mission:
        "Für dieses Trinôme ist kein Vertrag vorhanden. Bitte fügen Sie einen hinzu, um Missionen hinzufügen zu können.",
      no_active_contract_activity:
        "Für dieses Trinôme ist kein Vertrag vorhanden. Bitte fügen Sie einen hinzu, um Aktivitäten hinzufügen zu können.",
    },
    training: {
      triad_list: "Liste der Trinômes anzeigen",
    },
    archived_training_course: ({ plural, named }) =>
      plural([`Archivierte ${named("label")}s anzeigen`, `Archivierte ${named("label")}s anzeigen`]),
    unarchived_training_course: ({ plural, named }) =>
      plural([`Aktive ${named("label")}s anzeigen`, `Aktive ${named("label")}s anzeigen`]),
    Download_the_booklet: "Das Heft herunterladen",
    Download_the_booklet_with_documents: "Das Heft mit seinen Dokumenten herunterladen",
    Download_key_dates: "Schlüsseldaten herunterladen",
    session_lock: "Diese Sitzung ist noch nicht zur Eingabe geöffnet.",
    skill_lock:
      "Sie können diese Kompetenz nicht bearbeiten, \nda sie durch Ihre Antworten auf \ndie Fragebögen berechnet wird oder Ihnen \nnicht zugewiesen ist",
    driverLicence: {
      config: "Verwaltung der Führerschein-B-Beihilfen",
      confirmation_send: "Der für Ihre Akte zuständige Pilot wurde über Ihren Antrag informiert.",
      progress: {
        paymentDate: "Zahlungsdatum",
        requestDate: "Antragsdatum",
        transmissionDate: "Übermittlungsdatum an den Finanzdienst",
        validationDate: "Validierungsdatum",
      },
    },
    skill: {
      rate_by_profil: "Füllrate der Kompetenzen nach Profil",
    },
  },
  driver_licence: {
    info: "Ihre Akte wird gesendet, wenn alle Anhänge eingereicht wurden",
  },
};
